export default "__VITE_ASSET__CfZiP2P7__"